import styled from 'styled-components';
import React from 'react';
import Modal from '../common/Modal';
import Loader from '../common/Loader';
export const LoadingModal = () => {
    return (React.createElement(Modal, { modalVisible: true, maxWidth: 130, hideCloseBtn: true },
        React.createElement(LoadingWindow, null,
            React.createElement(LoadingMessage, null, "Loading..."),
            React.createElement(Loader, { color: "#bbb" }))));
};
const LoadingWindow = styled.div `
  height: 115px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;
const LoadingMessage = styled.div `
  font-size: 15px;
  color: #aaa;
  margin-bottom: 18px;
`;
